<section class="bn-as-fourhundred-policy" id="transHistory">
    <div class="margin-top mt40 w-100" *ngIf="!policy?.isNewPolicy">
        <ng-container *ngIf="!scheduledBills || !billingHistory; else showSchedule">
            <ng-container *ngIf="billingHistory && policy?.policynumber.policyNumber.length===10">
                <h2 class="title no-border billing-title mb-2" [ngClass]="{'dm-sans-medium': !isAcmic}">
                    {{ 'PAYMENT_HISTORY' | translate }}
                </h2>
                <div class="billing-mobile-table custom_pad">
                    <table class="table bn-table-stripped billing-table margin-bottom mb32">
                        <tbody class="fake-black-color">
                            <tr class="row-content border-full grey-border lite-grey-color">
                                <td *ngIf="policy?.policynumber?.policyNumber.length > 6">
                                </td>
                                <th class="billing-table-width">
                                    {{ 'DATE_BILLED' | translate }}
                                </th>
                                <th class="billing-table-width">
                                    {{ 'DESCRIPTION' | translate }}
                                </th>
                                <th class="billing-table-width">
                                    {{ 'AMOUNT' | translate }}
                                </th>
                                <th class="billing-table-width nopad" class="text-center">
                                    <p class="margin-bottom mb-0">{{ 'Date Due' | translate }}</p>
                                    <p class="margin-bottom mb-0">{{ 'EFFECTIVE_DATE' | translate }}</p>
                                </th>
                            </tr>
                            <ng-container
                                *ngFor="let historyPayment of billingHistory | sortBillsByDate : 'desc' : 'historyPayment.dateIssued'">
                                <tr class="row-content border-full grey-border">
                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6" class="blue-text bill-svg"
                                        [ngClass]="{'hover':policyId?.length===10}">
                                        <svg-pdf-document-svg
                                            (click)="onDownloadDocument(historyPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                    </td>

                                    <td class="billing-table-width"(click)="onDownloadDocument(historyPayment?.invoiceNumber)">
                                        
                                            {{
                                            historyPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                            historyPayment?.dateIssued | customDateFormat
                                            }}
                                        
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.amountPaid | currency }}
                                    </td>
                                    <td class="billing-table-width" class="text-center">
                                        <p class="margin-bottom mb-0">
                                            
                                                {{
                                                historyPayment?.dueDate
                                                ==='9999-09-09T00:00:00.000+0000' ? '' : historyPayment?.dueDate |
                                                customDateFormat
                                                }}
                                            
                                        </p>
                                        <p class="margin-bottom mb-0">
                                            
                                                {{
                                                historyPayment?.datePaid
                                                ==='9999-09-09T00:00:00.000+0000' ? '' : historyPayment?.datePaid |
                                                customDateFormat
                                                }}
                                            
                                        </p>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>

            <ng-container *ngIf="billingHistory && policy?.policynumber.policyNumber.length===6">
                <!-- Added for AS400 history bills-->
                <h2 class="title no-border billing-title mb-2" [ngClass]="{'dm-sans-medium': !isAcmic}">

                    {{ 'PAYMENT_HISTORY' | translate }}
                </h2>
                <div class="billing-mobile-table bn-billing-hist-table custom_pad payment-table">
                    <table class="table bn-table-stripped billing-table margin-bottom mb32">
                        <tbody class="fake-black-color">
                            <tr class="row-content border-full grey-border lite-grey-color">
                                <td *ngIf="policy?.policynumber?.policyNumber.length > 6">
                                </td>
                                <th class="billing-table-width" >
                                    {{ 'DUE_DATE' | translate }}
                                </th>
                                <th class="billing-table-width" >
                                    {{ 'DESCRIPTION' | translate }}
                                </th>
                                <th class="billing-table-width" >
                                    {{ 'MINIMUM_AMOUNT_DUE' | translate }}
                                </th>
                                <th class="billing-table-width" >
                                    {{ 'AMOUNT_APPLIED_FULL' | translate }}
                                </th>
                                <th class="billing-table-width" >
                                    {{ 'DATE_APPLIED' | translate }}
                                </th>
                            </tr>
                            <ng-container
                                *ngFor="let historyPayment of billingHistory | sortBillsByDate : 'desc' : 'dateIssued'">
                                <tr class="row-content border-full grey-border" class="text-center">
                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6" class="blue-text bill-svg"
                                        [ngClass]="{'hover':policyId?.length===10}">
                                        <svg-pdf-document-svg
                                            (click)="onDownloadDocument(historyPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                    </td>

                                    <td class="billing-table-width">
                                        
                                            {{
                                            historyPayment?.dueDate ==='9999-09-09T00:00:00.000+0000' ? '' :
                                            historyPayment?.dueDate | customDateFormat
                                            }}
                                        
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.amountPaid | currency }}
                                    </td>
                                    <td class="billing-table-width text-center" *ngIf="historyPayment?.datePaid !== 'Multiple'; else multiplePayments">
                                            {{
                                            historyPayment?.appliedAmount | currency
                                            }}
                                       
                                    </td>
                                    <td class="billing-table-width">
                                        
                                            <ng-container
                                                *ngIf="historyPayment?.datePaid !== 'Multiple'; else showMultiple">
                                                {{
                                                historyPayment?.datePaid==='9999-09-09T00:00:00.000+0000' ||
                                                historyPayment?.datePaid==='' ?
                                                'NA' : historyPayment?.datePaid | customDateFormat
                                                }}
                                            </ng-container>

                                            <ng-template #showMultiple>
                                                {{ 'Multiple' }}
                                            </ng-template>
                                        

                                        <ng-template #multiplePayments>
                                        <td>
                                            <mapfre-modal [modalOptions]="multiplePaymentModal" (click)="hideModal()"
                                                    [buttonString]="historyPayment?.appliedAmount.toString() | currency"
                                                    [hideModal]="hideModalOnRoute">
                                                    <div class="modal-body">
                                                        <hr class="margin-bottom mb24 no-margin-top" />

                                                        <table class="table billing-table payment-table">
                                                            <tbody class="fake-black-color">
                                                                <tr
                                                                    class="row-content border-full grey-border lite-grey-color">
                                                                    <th class="billing-table-width" class="text-center">
                                                                        {{ 'DATE_APPLIED' | translate }}
                                                                    </th>
                                                                    <th class="billing-table-width" class="text-center">
                                                                        {{ 'DESCRIPTION' | translate }}
                                                                    </th>
                                                                    <th class="billing-table-width" class="text-center">
                                                                        {{ 'AMOUNT_APPLIED' | translate }}
                                                                    </th>
                                                                </tr>

                                                                <ng-container
                                                                    *ngFor="let payment of historyPayment?.historyBillPayments">
                                                                    <tr class="row-content border-full grey-border"
                                                                        class="text-center">
                                                                        <td class="billing-table-width">
                                                                            {{ payment.appliedDate |
                                                                                customDateFormat
                                                                                }}
                                                                        </td>
                                                                        <td class="billing-table-width">
                                                                            {{ payment.transactionType }}
                                                                        </td>
                                                                        <td class="billing-table-width">
                                                                            {{ payment.appliedAmount | currency
                                                                                }}
                                                                        </td>
                                                                    </tr>
                                                                </ng-container>

                                                            </tbody>
                                                        </table>


                                                    </div>
                                            </mapfre-modal>
                                        </td>
                                        </ng-template>

                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>

            <ng-container *ngIf="scheduledBills">
                <h2 class="title no-border">
                    <div class="">
                        <ng-container *ngIf="isAcmic; else activeCalendarIcon">
                            <img src="assets/img/images/icon-calendar-acmic.svg" alt="calendar icon" />
                        </ng-container>
                        <ng-template #activeCalendarIcon>
                            <svg-calendar-mono-color-svg></svg-calendar-mono-color-svg>
                        </ng-template>
                    </div>
                    {{ 'SCHEDULED_PAYMENTS' | translate }}
                </h2>
                <div class="billing-mobile-table custom_pad">
                    <ng-container *ngIf="policy?.policynumber?.policyNumber.length > 6">
                        <table class="table claims-table w-100 margin-bottom mb32" *ngIf="schedualOrHistory">
                            <tbody class="fake-black-color">
                                <tr class="row-content border-full grey-border lite-grey-color">

                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">

                                    </td>
                                    <td class="billing-table-width">
                                        {{ 'DATE' | translate }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ 'DESCRIPTION' | translate }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ 'AMOUNT' | translate }}
                                    </td>
                                    <td class="billing-table-width" class="text-right">
                                        {{ 'Date Due' | translate }}
                                    </td>
                                </tr>
                                <ng-container
                                    *ngFor="let scheduledPayment of scheduledBills | sortBillsByDate : 'asc' : 'dateIssued' ">
                                    <tr class="row-content border-full grey-border">
                                        <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice && (scheduledPayment?.invoiceState.toLowerCase()==='billed' || scheduledPayment?.invoiceState.toLowerCase()==='due'); else noIcon"
                                            class="blue-text bill-svg" [ngClass]="{'hover':policyId?.length===10}">
                                            <svg-pdf-document-svg
                                                (click)="onDownloadDocument(scheduledPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                        </td>
                                        <ng-template #noIcon>
                                            <td
                                                *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">
                                            </td>
                                        </ng-template>
                                        <td class="billing-table-width">
                                            
                                                {{
                                                scheduledPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                                scheduledPayment?.dateIssued | date: 'shortDate'
                                                }}
                                            
                                        </td>
                                        <td class="billing-table-width">
                                            {{ scheduledPayment?.noticeType }}
                                        </td>
                                        <td class="billing-table-width">
                                            {{ scheduledPayment?.minAmountDue | currency }}
                                        </td>
                                        <td class="billing-table-width" class="text-right">
                                            
                                                {{
                                                scheduledPayment?.dateDue==='9999-09-09T00:00:00.000+0000' ? '' :
                                                scheduledPayment?.dateDue | date: 'shortDate'
                                                }}
                                            
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </ng-container>
                    <!-- Added for Legacy change -->
                    <ng-container *ngIf="policy?.policynumber?.policyNumber.length === 6">

                        <table class="table claims-table w-100 margin-bottom mb32" *ngIf="schedualOrHistory">
                            <tbody class="fake-black-color">
                                <tr class="row-content border-full grey-border lite-grey-color">

                                    <td class="billing-table-width">
                                        {{ 'Issue Date' | translate }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ 'Date Due' | translate }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ 'DESCRIPTION' | translate }}
                                    </td>
                                    <td class="billing-table-width" class="text-right">
                                        {{ 'MINIMUM_AMOUNT_DUE' | translate }}
                                    </td>
                                </tr>
                                <ng-container
                                    *ngFor="let scheduledPayment of scheduledBills | sortBillsByDate : 'asc' : 'dateIssued' ">
                                    <tr class="row-content border-full grey-border">
                                        <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice && (scheduledPayment?.invoiceState.toLowerCase()==='billed' || scheduledPayment?.invoiceState.toLowerCase()==='due'); else noIcon"
                                            class="blue-text bill-svg" [ngClass]="{'hover':policyId?.length===10}">
                                            <svg-pdf-document-svg
                                                (click)="onDownloadDocument(scheduledPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                        </td>
                                        <ng-template #noIcon>
                                            <td
                                                *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">
                                            </td>
                                        </ng-template>
                                        <td class="billing-table-width">
                                            
                                                {{
                                                scheduledPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                                scheduledPayment?.dateIssued | date: 'shortDate'
                                                }}
                                            
                                        </td>
                                        <td class="billing-table-width" class="text-right">
                                            
                                                {{
                                                scheduledPayment?.dateDue==='9999-09-09T00:00:00.000+0000' ? '' :
                                                scheduledPayment?.dateDue | date: 'shortDate'
                                                }}
                                            
                                        </td>
                                        <td class="billing-table-width">
                                            {{ scheduledPayment?.noticeType }}
                                        </td>
                                        <td class="billing-table-width">
                                            {{ scheduledPayment?.minAmountDue | currency }}
                                        </td>

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>

                    </ng-container>
                    <!-- Legacy change ends here -->
                </div>
            </ng-container>
        </ng-container>

        <ng-template #showSchedule>
            <nav class="tab-accordian-navigation w-100">
                <div class="tab-navigation">
                    <ul class="pl-0 d-table no-margin">
                        <li [ngClass]="{'active': schedualOrHistory }" class="width schedule-payment">
                            <a (click)="switchHistories('schedual')">{{ 'SCHEDULED_PAYMENTS' | translate }}</a>
                        </li>
                        <li [ngClass]="{'active': !schedualOrHistory }" class="width billing-history">
                            <a (click)="switchHistories('history')">{{ 'TRANSACTION_HISTORY' | translate }}</a>
                        </li>
                    </ul>
                </div>
            </nav>
            <div class="billing-mobile-table custom_pad">
                <ng-container *ngIf="policy?.policynumber?.policyNumber.length === 10">
                    <table class="table claims-table w-100 margin-bottom mb32" *ngIf="schedualOrHistory">
                        <tbody class="fake-black-color">
                            <tr class="row-content border-full grey-border lite-grey-color">
                                <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">

                                </td>
                                <td class="billing-table-width">
                                    {{ 'DATE' | translate }}
                                </td>
                                <td class="billing-table-width">
                                    {{ 'DESCRIPTION' | translate }}
                                </td>
                                <td class="billing-table-width">
                                    {{ 'AMOUNT' | translate }}
                                </td>
                                <td class="billing-table-width" class="text-right">
                                    {{ 'Date Due' | translate }}
                                </td>
                            </tr>
                            <ng-container
                                *ngFor="let scheduledPayment of scheduledBills | sortBillsByDate : 'asc' : 'dateIssued'">
                                <tr class="row-content border-full grey-border">
                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice && (scheduledPayment?.invoiceState.toLowerCase()==='billed' || scheduledPayment?.invoiceState.toLowerCase()==='due'); else noIcon"
                                        class="blue-text bill-svg" [ngClass]="{'hover':policyId?.length===10}">
                                        <svg-pdf-document-svg
                                            (click)="onDownloadDocument(scheduledPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                    </td>
                                    <ng-template #noIcon>
                                        <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">
                                        </td>
                                    </ng-template>
                                    <td class="billing-table-width">
                                       
                                            {{
                                            scheduledPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                            scheduledPayment?.dateIssued | date: 'shortDate'
                                            }}
                                        
                                    </td>
                                    <td class="billing-table-width">
                                        {{ scheduledPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ scheduledPayment?.minAmountDue | currency }}
                                    </td>
                                    <td class="billing-table-width" class="text-right">
                                        
                                            {{
                                            scheduledPayment?.dateDue==='9999-09-09T00:00:00.000+0000' ? '' :
                                            scheduledPayment?.dateDue | date: 'shortDate'
                                            }}
                                        
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </ng-container>

                <!-- Added for Legacy -->

                <ng-container *ngIf="policy?.policynumber?.policyNumber.length === 6">

                    <table class="table bn-table-stripped w-100 margin-bottom mb32" *ngIf="schedualOrHistory">
                        <thead class="fake-black-color">
                            <tr class="heading row-content border-full grey-border lite-grey-color">
                                <th class="bn-schedule-table-col-1 billing-table-width">
                                    {{ 'Issue Date' | translate }}
                                </th>
                                <th class="bn-schedule-table-col-2 billing-table-width">
                                    {{ 'Date Due' | translate }}
                                </th>
                                <th class="bn-schedule-table-col-3 billing-table-width">
                                    {{ 'DESCRIPTION' | translate }}
                                </th>
                                <th class="bn-schedule-table-col-4 billing-table-width">
                                    {{ 'MINIMUM_AMOUNT_DUE_SMALL_CASE' | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody class="fake-black-color">
                            <ng-container
                                *ngFor="let scheduledPayment of scheduledBills | sortBillsByDate : 'asc' : 'dateIssued' ">
                                <tr class="row-content border-full grey-border">
                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice && (scheduledPayment?.invoiceState.toLowerCase()==='billed' || scheduledPayment?.invoiceState.toLowerCase()==='due'); else noIcon"
                                        class="blue-text bill-svg" [ngClass]="{'hover':policyId?.length===10}">
                                        <svg-pdf-document-svg
                                            (click)="onDownloadDocument(scheduledPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                    </td>
                                    <ng-template #noIcon>
                                        <td *ngIf="policy?.policynumber?.policyNumber.length > 6 && downloadInvoice">
                                        </td>
                                    </ng-template>
                                    <td class="billing-table-width">
                                        {{
                                        scheduledPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                        scheduledPayment?.dateIssued | date: 'shortDate'
                                        }}
                                    </td>
                                    <td class="billing-table-width" class="">
                                        {{
                                        scheduledPayment?.dateDue==='9999-09-09T00:00:00.000+0000' ? '' :
                                        scheduledPayment?.dateDue | date: 'shortDate'
                                        }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ scheduledPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ scheduledPayment?.minAmountDue | currency }}
                                    </td>

                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                </ng-container>

                <!-- End Legacy changes -->

                <div class="table-scroll-for-mobile">
                <table class="table bn-table-stripped w-100 margin-bottom mb32" *ngIf="!schedualOrHistory"
                    [ngClass]="{ 'billing-mobile-table custom_pad payment-table': policy?.policynumber.policyNumber.length===6}">
                    <ng-container *ngIf="policy?.policynumber.policyNumber.length===10">
                        <tbody class="fake-black-color">
                            <tr class="row-content border-full grey-border lite-grey-color">
                                <td *ngIf="policy?.policynumber?.policyNumber.length > 6">
                                </td>
                                <td class="billing-table-width">
                                    {{ 'DATE_BILLED' | translate }}
                                </td>
                                <td class="billing-table-width">
                                    {{ 'DESCRIPTION' | translate }}
                                </td>
                                <td class="billing-table-width">
                                    {{ 'AMOUNT' | translate }}
                                </td>
                                <td class="billing-table-width" class="text-center nopad">
                                    <p class="margin-bottom mb-0">{{ 'Date Due' | translate }}</p>
                                    <p class="margin-bottom mb-0">{{ 'EFFECTIVE_DATE' | translate }}</p>
                                </td>
                            </tr>
                            <ng-container
                                *ngFor="let historyPayment of billingHistory | sortBillsByDate : 'desc' : 'dateIssued'">
                                <tr class="row-content border-full grey-border">
                                    <td class="blue-text bill-svg" [ngClass]="{'hover':policyId?.length===10}"
                                        *ngIf="policy?.policynumber?.policyNumber.length > 6">
                                        <div>
                                            <svg-pdf-document-svg
                                                (click)="onDownloadDocument(historyPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                        </div>
                                    </td>
                                    <td class="billing-table-width" (click)="onDownloadDocument(historyPayment?.invoiceNumber)">
                                            {{
                                            historyPayment?.dateIssued ==='9999-09-09T00:00:00.000+0000' ? '' :
                                            historyPayment?.dateIssued | date: 'shortDate'
                                            }}
                                       
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.amountPaid | currency }}
                                    </td>
                                    <td class="billing-table-width" class="text-center">
                                        <p class="margin-bottom mb-0">
                                            
                                                {{
                                                historyPayment?.dueDate
                                                ==='9999-09-09T00:00:00.000+0000' ? '' : historyPayment?.dueDate | date:
                                                'shortDate'
                                                }}
                                            
                                        </p>
                                        <p class="margin-bottom mb-0">
                                            
                                                {{
                                                historyPayment?.datePaid
                                                ==='9999-09-09T00:00:00.000+0000' ? '' : historyPayment?.datePaid | date:
                                                'shortDate'
                                                }}
                                            
                                        </p>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </ng-container>
                    <!-- Added for Legacy -->
                    <ng-container *ngIf="policy?.policynumber.policyNumber.length===6">
                        <thead class="fake-black-color">
                            <tr class="heading row-content border-full grey-border lite-grey-color">
                                <td *ngIf="policy?.policynumber?.policyNumber.length > 6">
                                </td>
                                <th class="bn-transaction-table-col-1 billing-table-width">
                                    {{ 'DUE_DATE' | translate }}
                                </th>
                                <th class="bn-transaction-table-col-2 billing-table-width">
                                    {{ 'DESCRIPTION' | translate }}
                                </th>
                                <th class="bn-transaction-table-col-3 billing-table-width">
                                    {{ 'MINIMUM_AMOUNT_DUE_SMALL_CASE' | translate }}
                                </th>
                                <th class="bn-transaction-table-col-4 billing-table-width">
                                    {{ 'AMOUNT_APPLIED_FULL' | translate }}
                                </th>
                                <th class="bn-transaction-table-col-5 billing-table-width">
                                    {{ 'DATE_APPLIED' | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody class="fake-black-color">
                            <ng-container
                                *ngFor="let historyPayment of billingHistory | sortBillsByDate : 'desc' : 'dateIssued'">
                                <tr class="row-content border-full grey-border" class="text-center">
                                    <td *ngIf="policy?.policynumber?.policyNumber.length > 6" class="blue-text bill-svg"
                                        [ngClass]="{'hover':policyId?.length===10}">
                                        <svg-pdf-document-svg
                                            (click)="onDownloadDocument(historyPayment?.invoiceNumber)"></svg-pdf-document-svg>
                                    </td>

                                    <td class="billing-table-width text-center">
                                        
                                            {{
                                            historyPayment?.dueDate ==='9999-09-09T00:00:00.000+0000' ? '' :
                                            historyPayment?.dueDate | customDateFormat
                                            }}
                                        
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.noticeType }}
                                    </td>
                                    <td class="billing-table-width">
                                        {{ historyPayment?.amountPaid | currency }}
                                    </td>
                                    <td class="billing-table-width" class="text-center" *ngIf="historyPayment?.datePaid !== 'Multiple'; else multiplePayments">
                                            {{
                                            historyPayment?.appliedAmount | currency
                                            }}
                                        
                                    </td>
                                    <td class="billing-table-width" class="text-center">

                                        
                                            <ng-container
                                                *ngIf="historyPayment?.datePaid !== 'Multiple'; else showMultiple">
                                                {{
                                                historyPayment?.datePaid==='9999-09-09T00:00:00.000+0000' ||
                                                historyPayment?.datePaid==='' ?
                                                'NA' : historyPayment?.datePaid | customDateFormat
                                                }}
                                            </ng-container>

                                            <ng-template #showMultiple>
                                                {{ 'Multiple' }}
                                            </ng-template>

                                        <ng-template #multiplePayments>
                                            <td>
                                            <mapfre-modal [modalOptions]="multiplePaymentModal" (click)="hideModal()"
                                                [buttonString]="historyPayment?.appliedAmount.toString() | currency"
                                                [hideModal]="hideModalOnRoute">
                                                <div class="modal-body">
                                                    <hr class="margin-bottom mb24 no-margin-top" />

                                                    <table class="table billing-table payment-table margin-bottom mb32">
                                                        <tbody class="fake-black-color">
                                                            <tr
                                                                class="row-content border-full grey-border lite-grey-color">
                                                                <th class="billing-table-width" class="text-center">
                                                                    {{ 'DATE_APPLIED' | translate }}
                                                                </th>
                                                                <th class="billing-table-width" class="text-center">
                                                                    {{ 'DESCRIPTION' | translate }}
                                                                </th>
                                                                <th class="billing-table-width" class="text-center ">
                                                                    {{ 'AMOUNT_APPLIED' | translate }}
                                                                </th>
                                                            </tr>

                                                            <ng-container
                                                                *ngFor="let payment of historyPayment?.historyBillPayments">
                                                                <tr class="row-content border-full grey-border"
                                                                    class="text-center">
                                                                    <td class="billing-table-width">
                                                                        {{ payment.appliedDate |
                                                                            customDateFormat
                                                                            }}
                                                                    </td>
                                                                    <td class="billing-table-width">
                                                                        {{ payment.transactionType }}
                                                                    </td>
                                                                    <td class="billing-table-width">
                                                                        {{ payment.appliedAmount | currency
                                                                            }}
                                                                    </td>
                                                                </tr>
                                                            </ng-container>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </mapfre-modal>
                                        </td>
                                        </ng-template>                                
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </ng-container>
                    <!-- Legacy code ends -->
                    

                </table>
            </div>
            <div class="bn-e-bill-access" *ngIf="(policy?.policyFlags?.isEbill === 'ENROLLED' && policy?.policynumber?.policyNumber.length === 6)">
                <div>
                    <span class="bn-ebil-text">E-bill</span>
                    <span class="bn-ebil-sub">view your bills online.</span>
                </div>
                <div class="cursor-pointer" (click)="viewEBILL()">
                    <span class="bn-ebil-access-text">Access</span><img src="assets/img/images/icon-simple-arrow-right-red.svg" />
                </div>
            </div>
            <!-- <table class="table documents-table" *ngIf="(policy?.policyFlags?.isEbill == 'ENROLLED' && policy?.policynumber?.policyNumber.length == 6) || policy?.policynumber?.policyNumber.length > 6">
                <tbody>
                    <tr class="row row-content" (click)="viewEBILL($event)" *ngIf="policyId?.length === 6">
                        <td class="col-auto col-type text-center padding-left pl16" scope="row">
                            <div class="circle-with-type"> {{ 'B' | documentType }}</div>
                        </td>
                        <td class="col col-name no-padding-left">
                            {{ 'eBILL' }}
                            <span class="legal disclaimer small font-color">{{ 'View your bills online' }}</span>
                        </td>
                        <td class="col-auto col-view text-center view-padding">
                            <div class="documents-view-col">
                                <span class="align-top view-copy">{{'ACCESS' | translate}}</span>
                                <i class="material-icons align-top">keyboard_arrow_right</i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table> -->
            </div>
        </ng-template>
    </div>

</section>

